import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  createProductSuccess,
  createProductFailure,
  getProductListSuccess,
  getProductListFailure,
  updateProductSuccess,
  updateProductFailure,
  updateStatusProductFailure,
  updateStatusProductSuccess,
  viewProductSuccess,
  viewProductFailure,
  getRenewableLessonTypeProductValueSuccess,
  getRenewableLessonTypeProductValuefailure,
  getRenewableSubLessonTypeProductValueSuccess,
  getRenewablesubLessonTypeProductValuefailure,
  viewlessionSuccess,
  viewlessionFailure,
  editlessionSuccess,
  viewsublessionsuccess,
  viewsublessionfailure,
  editlessionFailure,
  editlessionsuccess,
  editsublessionsuccess,
  updatelessionstatussuccess,
  updatelessionstatusfailure,
  updatesublessionstatussuccess,
  updatesublessionstatusfailure,
  getCurriculumheadingsuccess,
  getCurriculumheadingfailure,
  deleteproduct,
  deleteproductsuccess,
  deleteproductfailure,
  getcategory,
  deletePerticularSubLession,
  deletePerticularSubLessionfailure,
  deletePerticularSubLessionsuccess,
  getcategorysuccess,
  getcategoryfailure,
} from "../../actions";
import {
  CREATE_PRODUCT,
  DELETE_PRODUCT,
  EDIT_LESSON,
  EDIT_SUB_LESSON,
  GET_CURRICULUM_HEADING,
  GET_PRODUCT_LIST,
  GET_VIEW_LESSON,
  GET_VIEW_SUB_LESSON,
  RENEWABLE_LESSON_ADD_SUB_TYPE,
  RENEWABLE_LESSON_ADD_TYPE,
  RENEWABLE_LESSON_SUBMIT,
  UPDATE_LESSION_STATUS,
  UPDATE_PRODUCT,
  UPDATE_STATUS_PRODUCT,
  UPDATE_SUB_LESSION_STATUS,
  VIEW_PRODUCT,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILURE,
  DELETE_PARTICULAR_PRODUCT
} from "../../Actions/types";
import api from "../../../helper/api";

function* createProduct(action) {
  try {
    const response = yield api.post(
      "/admin/products/add-product",
      action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        createProductSuccess({ createProductData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createProductFailure({ createProductError: e }));
  }
}

function* getProductList(action) {
  try {
    const response = yield api.post(
      "/admin/products/product-list",
      action?.payload?.form
    );

    
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(getProductListSuccess({ getProductListData: response?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    console.log(e, "ERRORRRRRRRRR")
    toast.error(e?.response?.data?.message);
    yield put(getProductListFailure({ getProductListError: e }));
  }
}

function* updateProduct(action) {
  // console.log(action?.payload)
  // const form = {
  //   productName: action?.payload?.form.productName,
  //   description: action?.payload?.form?.description,
  //   image: action?.payload?.form?.image,
  //   animatedFile: action?.payload?.form?.animatedFile,
  //   jsonFile: action?.payload?.form?.jsonFile,
  //   imageJSON: action?.payload?.form?.imageJSON,
  //   // categoryId: action?.payload?.form?.categoryId,
  //   curriculumSelection: action?.payload?.form?.curriculumSelection,
  //   productType: action?.payload?.form?.productType,
  //   code: action?.payload?.form?.code,
  //   categoryId:action?.payload?.form?.categoryId,
  //   lessonPlan:action?.payload?.form?.lessonPlan,
  //   spiFile:action?.payload?.form?.spiFile,
  // };


  try {
    const response = yield api.put(
      `/admin/products/edit-product/${action?.payload?.id}`,
       action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateProductSuccess({ updateProductData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateProductFailure({ updateProductError: e }));
  }
}

function* updateStatusProduct(action) {
  try {
    const response = yield api.put(
      `/admin/products/change-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateStatusProductSuccess({
          updateStatusProductData: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateStatusProductFailure({ updateStatusProductError: e }));
  }
}

function* viewProduct(action) {
  try {
    const response = yield api.get(
      `/admin/products/view-product/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(viewProductSuccess({ viewProductData: response?.data?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewProductFailure({ viewProductError: e }));
  }
}

// renewable add lessons
function* renewableAddlesson(action) {
  try {
    const response = yield api.post(
      "/admin/products/add-lessonTypes",
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getRenewableLessonTypeProductValueSuccess({
          createAddlessondata: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(
      getRenewableLessonTypeProductValuefailure({ createAddlessonerror: e })
    );
  }
}

// renewable add sublessons
function* renewableAddSublesson(action) {
  try {
    const response = yield api.post(
      `/admin/products/add-lessons/${action?.payload?.id}`,

      action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getRenewableSubLessonTypeProductValueSuccess({
          createSubAddlessondata: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(
      getRenewablesubLessonTypeProductValuefailure({
        createSubAddlessonerror: e,
      })
    );
  }
}

// renewable submit products
function* submitrenwableproduct(action) {
  try {
    const response = yield api.put(
      "/admin/products/update-lesson",
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getRenewableLessonTypeProductValueSuccess({
          createAddlessondata: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(
      getRenewableLessonTypeProductValuefailure({ createAddlessonerror: e })
    );
  }
}

// view lession
function* viewLession(action) {
  try {
    const response = yield api.get(
      `admin/products/view-lessonTypes/${action?.payload?.payload}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      // toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewlessionSuccess({
          viewlessiontitle: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      // toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewlessionFailure({ viewlessiontitleerror: e }));
  }
}

// edit lession

function* editLession(action) {
  try {
    const response = yield api.put(
      `/admin/products/update-lessonTypes/${action?.payload?.id}`,
      action?.payload?.payload
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data);
      yield put(
        editlessionSuccess({
          editlession: response?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(editlessionFailure({ editlessionerror: e }));
  }
}

// view   sub lession
function* viewSubLession(action) {
  try {
    const response = yield api.get(
      `/admin/products/view-lesson/${action?.payload?.payload}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      // toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data);
      yield put(
        viewsublessionsuccess({
          viewsublessiondata: response?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      // toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewsublessionfailure({ viewsublessionerror: e }));
  }
}

// edit lession

function* editSubLession(action) {
  // console.log(action, 336);
  try {
    const response = yield api.put(
      `/admin/products/update-lesson/${action?.payload?.id}`,
      action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data);
      yield put(
        editsublessionsuccess({
          editsublessiondata: response?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(editlessionFailure({ editsublessionerror: e }));
  }
}

function* updatelessionstatus(action) {
  try {
    const response = yield api.put(
      `/admin/products/change-lessonType-status/${action?.payload?.form}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updatelessionstatussuccess({
          updatelessionstatus: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updatelessionstatusfailure({ updatelessionstatuserror: e }));
  }
}

function* updatesublessionstatus(action) {
  try {
    const response = yield api.put(
      `/admin/products/change-lesson-status/${action?.payload?.form}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updatesublessionstatussuccess({
          updatesublessionstatus: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(
      updatesublessionstatusfailure({ updatesublessionstatuserror: e })
    );
  }
}

function* getCurriculumheading(action) {
  try {
    const response = yield api.get(
      `/admin/heading/get-heading`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(getCurriculumheadingsuccess({ getcurriculamheading: response?.data?.data }));
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getCurriculumheadingfailure({ getcurriculamheadingerror: e }));
  }
}

function* deleteProducts(action) {
  // console.log("first",action)
  try {
    const response = yield api.delete(
      `/admin/products/delete-product/${action?.payload?.form?.id?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        deleteproductsuccess({ getdeleteproduct: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(deleteproductfailure({ deleteproducterror: e }));
  }
}

function* getCategory(action) {
  // console.log("first",action)
  try {
    const response = yield api.get(
      `/admin/category/get-category`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      // toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        getcategorysuccess({ getcategory: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getcategoryfailure({ getcategoryerror: e }));
  }
}


// function* deletePerticularSubLessionImage(action) {
//    console.log("first",action)
//   try {
//     const response = yield api.delete(
//       `/admin/products/delete-image`,
//       action?.payload?.form
//     ),
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//     if (response?.status === 200 && response?.data?.code === 200) {
//       toast.success(response?.data?.message);

//       yield call(action?.payload?.callback, response?.data?.data);
//       yield put(
//         deletePerticularSubLessionsuccess({ deletePerticularSubLession: response?.data?.data })
//       );
//     } else if (response?.status === 200 && response?.data?.code !== 200) {
//       toast.error(response?.data?.message);
//     }
//   } catch (e) {
//     toast.error(e?.response?.data?.message);
//     yield put(deletePerticularSubLessionfailure({ deleteproducterror: e }));
//   }
// }

function* deletePerticularSubLessionImage(action) {
  try {
    const response = yield call(api.delete, '/admin/products/delete-image', {
      data: action.payload.form,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200 && response.data.code === 200) {
      yield call(action.payload.callback, response.data.data);
      yield put(deletePerticularSubLessionsuccess(response.data.data));
      toast.success(response.data.message); // Assuming message is part of your response data
    } else if (response.status === 200 && response.data.code !== 200) {
      toast.error(response.data.message); // Assuming message is part of your response data
    }
  } catch (e) {
    toast.error(e.response?.data?.message || 'Failed to delete image'); // Handle error messages
    yield put(deletePerticularSubLessionfailure(e));
  }
}

function* createProductWatcher() {
  yield takeLatest(CREATE_PRODUCT, createProduct);
}

function* getProductListWatcher() {
  yield takeLatest(GET_PRODUCT_LIST, getProductList);
}
function* updateProductWatcher() {
  yield takeLatest(UPDATE_PRODUCT, updateProduct);
}
function* updateStatusProductWatcher() {
  yield takeLatest(UPDATE_STATUS_PRODUCT, updateStatusProduct);
}
function* viewProductWatcher() {
  yield takeLatest(VIEW_PRODUCT, viewProduct);
}

function* renewableAddlessonWatcher() {
  yield takeLatest(RENEWABLE_LESSON_ADD_TYPE, renewableAddlesson);
}

function* renewableAddSublessonWatcher() {
  yield takeLatest(RENEWABLE_LESSON_ADD_SUB_TYPE, renewableAddSublesson);
}
function* viewLessionWatcher() {
  yield takeLatest(GET_VIEW_LESSON, viewLession);
}
function* editLessionWatcher() {
  yield takeLatest(EDIT_LESSON, editLession);
}
function* submitrenewableproductWatcher() {
  yield takeLatest(RENEWABLE_LESSON_SUBMIT, submitrenwableproduct);
}

function* ViewsubLessionwatcher() {
  yield takeLatest(GET_VIEW_SUB_LESSON, viewSubLession);
}
function* editsubLessionwatcher() {
  yield takeLatest(EDIT_SUB_LESSON, editSubLession);
}

function* updatelessionstatuswatcher() {
  yield takeLatest(UPDATE_LESSION_STATUS, updatelessionstatus);
}

function* updatesublessionstatuswatcher() {
  yield takeLatest(UPDATE_SUB_LESSION_STATUS, updatesublessionstatus);
}


function* getCurriculumheadingwatcher() {
  yield takeLatest(GET_CURRICULUM_HEADING, getCurriculumheading);
  
}
function* deleteproductwatcher() {
  yield takeLatest(DELETE_PRODUCT, deleteProducts);
  
}

function* deletePerticularSubLessiowatcher() {
  yield takeLatest(DELETE_PARTICULAR_PRODUCT, deletePerticularSubLessionImage);
  
}

function* getcategorywatcher() {
  yield takeLatest(GET_CATEGORIES, getCategory);
  
}



export default function* productManagementSaga() {
  yield all([
    createProductWatcher(),
    getProductListWatcher(),
    updateProductWatcher(),
    updateStatusProductWatcher(),
    viewProductWatcher(),
    renewableAddlessonWatcher(),
    renewableAddSublessonWatcher(),
    submitrenewableproductWatcher(),
    viewLessionWatcher(),
    editLessionWatcher(),
    ViewsubLessionwatcher(),
    editsubLessionwatcher(),
    updatelessionstatuswatcher(),
    updatesublessionstatuswatcher(),
    getCurriculumheadingwatcher(),
    deleteproductwatcher(),
    getcategorywatcher(),
    deletePerticularSubLessiowatcher()
  ]);
}
